/**
 * Created by Ning Jiang on 2021-09-17.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeGameConfig} from "../ElGordosRevengeGameConfig";

export class XBetController extends PIXI.Container {

    public static boostedNames:string[] = ["BOOSTED_BET_1", "BOOSTED_BET_2", "BOOSTED_BET_3", "BOOSTED_BET_4"];

    private _featureAllowed:boolean;

    private _featureVisible:boolean = false;
    public set featureVisible(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }

        this._featureVisible = value;
        if(ElGordosRevenge.xBetView) {
            ElGordosRevenge.xBetView.featureVisible = this._featureVisible;
        }
    }

    private _selectedIndex:number = 0;
    public set selectedIndex(value:number) {
        if(!this._featureAllowed) {
            return;
        }

        if(value != this._selectedIndex) {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.XBET[value]});
        }

        this._selectedIndex = value;
        if(ElGordosRevenge.xBetView) {
            ElGordosRevenge.xBetView.selectedIndex = this._selectedIndex;
        }

        // selectedIndex can only change for normal mode
        if(ElGordosRevenge.model.data.nextMode === GameMode.NORMAL) {
            ElGordosRevenge.reels.forEach(reel => {
                reel.setCurrentReelSet(ElGordosRevengeGameConfig.getReelSetName(ElGordosRevenge.model.data.nextMode));
            });
        }
    }

    public get selectedIndex() {
        return this._selectedIndex;
    }

    constructor() {
        super();

        this._featureAllowed = SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        if(!this._featureAllowed) {
            return;
        }

        SlotGame.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => this.onSelectedFeatureBetChanged());
    }

    private onSelectedFeatureBetChanged():void {
        const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();

        if(activeBetFeature && XBetController.boostedNames.includes(activeBetFeature.name)) {
            this.selectedIndex = XBetController.boostedNames.indexOf(activeBetFeature.name) + 1;
        } else {
            this.selectedIndex = 0;
        }
    }

    public start():void {
        if(!this._featureAllowed) {
            return;
        }

        const nextMode = ElGordosRevenge.model.data.nextMode;
        this.featureVisible = nextMode === GameMode.NORMAL;
        this.onSelectedFeatureBetChanged();
    }
}
